import { useEffect } from 'react';
import { isClosed } from '@deephaven/jsapi-utils';

/**
 * React hook that closes a given widget when the reference changes or when the
 * component unmounts.
 * @param widget The widget to close
 */
export default function useWidgetClose(widget) {
  useEffect(() => () => {
    if (widget == null) {
      return;
    }
    if (!isClosed(widget)) {
      var _widget$close;
      (_widget$close = widget.close) === null || _widget$close === void 0 || _widget$close.call(widget);
    }
  }, [widget]);
}

/**
 * @deprecated Use `useWidgetClose` instead.
 */
export var useTableClose = useWidgetClose;
//# sourceMappingURL=useWidgetClose.js.map